const doc = [({"se":({"js":({"routes":({"user":({"school_class_check_ins":({"user_lobby":({"start":"Starta"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;